import { Title } from "@mgdx/ui/components/Title";

import styles from "./index.module.css";

export type ErrorForMccmAppProps = EmptyObject;

export const ErrorForMccmApp = (props: ErrorForMccmAppProps) => (
  <div className={styles.container}>
    <div className={styles.layout}>
      <div className="mb-11">
        <div className={styles.content}>
          <img src="/images/icon_error.svg" alt="" width="120" height="120" decoding="async" />
          <Title as="h1" fontSize="xm" className="mt-6">
            エラーが発生しました
          </Title>
          <div className="mt-3 text-center">
            <p className={styles.paragraph}>
              {"恐れ入りますが、\nしばらく時間を置いて\n再度ログイン操作をお願いします。"}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);
